import { h, Component } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import Store from 'store/store';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import CalendarRemindButtons from 'components/bolt/calendarRemind/calendarRemindButtons';
import HTML from 'components/core/html/html';

import s from 'components/bolt/calendarRemind/calendarRemind.sss';

export default class CalendarRemind extends Component {

	constructor(props) {
		super(props);
		this.closeOverlay = this.closeOverlay.bind(this);
	}


	closeOverlay({ target }) {
		if (target === this.container) {
			Store.emit('CLOSE_CAL_REMIND');
		}
	}


	render({ appData, open, offsetTop }) {
		if (!open) {
			return;
		}

		const { copy } = appData;
		const store = Store.get();

		let siteUrl = accessNested(appData, 'meta.url', '');
		siteUrl = siteUrl.replace(/https:\/\//, '');
		const liveDate = accessNested(this.props, 'appData.meta.dates.live') || accessNested(this.props, 'appData.meta.dates.boxOffice') || accessNested(this.props, 'appData.meta.dates.release');
		const remindMeDateWithOffset = new Date(liveDate);
		const remindMeDate = new Date( remindMeDateWithOffset.getTime() - remindMeDateWithOffset.getTimezoneOffset() * -60000 );
		const dateTimeCopy = accessNested(copy, 'baseCopy.$DATETIME_LOCALE', {});
		const dateTimeFormat = dateTimeCopy.calendarReminderFormat || 'dddd, dd MMM yyyy';
		const formattedDate = formatDateTime(new Date(remindMeDate), dateTimeFormat, dateTimeCopy);
		const calObj = accessNested(appData, 'header.powsterHeader.calendars', {});

		const summary = copy.baseCopy[calObj.calEventTitle] || calObj.calEventTitle || '';
		const description = copy.baseCopy[calObj.calEventBody] || calObj.calEventBody;
		const location = copy.baseCopy[calObj.calEventLocation] || calObj.calEventLocation || '';
		const chooseCalCopy = copy.baseCopy[calObj.chooseCalCopy] || calObj.chooseCalCopy || 'Choose a calendar';

		const fontStyles = accessNested(appData, 'styling.fontVariables');

		let style = {};
		const externalCookieBanner = accessNested(store, 'externalCookieBanner', false);
		const isMobile = !accessNested(store, 'client.isDesktopSize', false);
		const externalBannerOpenMobile = externalCookieBanner.bannerOpen && isMobile;

		if (offsetTop && typeof window !== 'undefined') {
			// make the overlay scrollable if the evidon banner is open
			style = {
				height: (window.innerHeight - offsetTop) + 'px',
				top: offsetTop + 'px',
			};
		}

		if (externalBannerOpenMobile) {
			style.overflowY = 'scroll';
			style.display = 'block';
		}

		return (
			<div style={style} class={s.container} onClick={this.closeOverlay} ref={ref => this.container = ref}>
				<BurgerMenu
					type='close'
					calendarRemind
					extraClass={s.calendarRemindCloseButton}
				/>
				<div class={s.notepad} role='dialog' style={externalBannerOpenMobile && { margin: '100px auto' }}>
					<div class={s.header}>
						<div class={s.hole}/>
						<div class={s.hole}/>
					</div>
					<div class={s.content}>
						<div class={s.releaseDetails}>
							<HTML tag="span" class={joinClasses(s.title, fontStyles.headerCalendarReminderTitle)} markdown content={summary} />
							<span class={joinClasses(s.date, fontStyles.headerCalendarReminderBody)}>{formattedDate}</span>
							<span class={s.vanity}>{siteUrl}</span>
						</div>
						<CalendarRemindButtons 
							remindMeDate={remindMeDate}
							summary={summary}
							description={description}
							location={location}
							calObj={calObj}
							isShowtimes
							chooseCalCopy={chooseCalCopy}
						/>
					</div>
				</div>
			</div>
		);
	}
}
